export class UserTypeService {
    dataFromService;
}
